export default __webpack_public_path__ + "static/media/imghomepagebanner 3.62e4ae0c.webp";